import { initialState } from './initialState';
import { createReducer, dataAs, requestCases } from './requestState';

export default createReducer(initialState, {
  ...requestCases('USER_AUTH', { success: dataAs('userData') }),
  ...requestCases('GET_TRANSLATOR', { success: dataAs('language') }),
  ...requestCases('LOG_OUT', { success: () => ({ userData: '', language: '' }) }),
  ...requestCases('PASSWORD_RESET', { success: dataAs('password_reset') }),
  ...requestCases('PASSWORD_SET', { success: dataAs('password_set') }),

  // A new userData and a new user, merged with the payload: writing through the previous state
  // left the old and the new state sharing one object, so `state.auth.userData` subscribers never
  // saw the change. After a logout (userData "") there is no session to merge into, and a late
  // profile refresh must not build one.
  GET_USER: (state, action) =>
    state.userData
      ? {
          ...state,
          isLoading: false,
          success: true,
          userData: { ...state.userData, user: { ...state.userData.user, ...action.payload } },
          error: false,
        }
      : state,
});
